import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NotificationsState } from '../states/notifications.state';
import { NotificationCategories } from '@core/domain/model/notifications/notification.model';

const rootSelector = createFeatureSelector<NotificationsState>('notifications');

const counters = createSelector(rootSelector, (state) => state.counters);

export const notificationsSelectors = {
  currentCategory: createSelector(rootSelector, (state) => state.currentCategory),
  notifications: createSelector(rootSelector, (state) => state.notifications),
  notificationsError: createSelector(rootSelector, (state) => state.error),
  counters: createSelector(rootSelector, (state) => state.counters),
  unreadCounter: createSelector(counters, (counters) => counters.unread),
  canRead: createSelector(counters, (counters) => counters.unread > 0),
  canArchive: createSelector(counters, (counters) => counters[NotificationCategories.ALL] > 0),
};
